/**
 * This object lists the column options available for the system item table
 * @param {Object} bodyComponent - The component to be rendered for that column
 * @param {String} dataField - The path of the field to retrieve the value
 * @param {String} name - Then name of the column
 * @param {String} sortBy - The field on which the data should be sorted for this column
 */
const metadata = {
  administratorSudo: {
    classNames: {
      heading: ['simpleTextColumn'],
    },
    dataField: 'attributes.sudo.enabled',
    name: 'Global Admin/Sudo',
  },
  defaultDeviceGroup: {
    bodyComponent: 'DefaultDeviceGroup',
    name: 'Default Group',
  },
  passwordlessSudo: {
    classNames: {
      heading: ['simpleTextColumn'],
    },
    dataField: 'attributes.sudo.withoutPassword',
    name: 'Global Passwordless Sudo',
  },
};

Object.keys(metadata).forEach((key) => {
  metadata[key].headingText = metadata[key].name;
});

export const mainPanelGroupItemTableColumnOptions = [
  metadata.administratorSudo,
  metadata.passwordlessSudo,

];

export default metadata;
